import styled from 'styled-components';

const VideoWrapper = styled.div<{
  ratio: number;
}>`
  position: relative;
  overflow: hidden;
  padding-bottom: ${({ ratio }) => `${100 / ratio}%`};

  .ytcover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    object-fit: cover;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    opacity: 0;
    transition: opacity 2.4s ease 0s;
  }
`;

export { VideoWrapper };
